import classnames from "classnames";
import Link from "next/link";
import formatPrice from "@/lib/formatPrice";
import styles from "@/styles/Payment.module.scss";
import processStyles from "@/styles/Process.module.scss";
import formStyles from "@/styles/Form.module.scss";
import routes from "@/lib/routes";
import { useState, useCallback, useEffect } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RecommendArticleForm(_ref) {
  let {
    recommendArticle = {},
    onChange
  } = _ref;
  const {
    courses,
    products
  } = recommendArticle;
  if (!courses && !products) return null;
  return /*#__PURE__*/_jsx("div", {
    className: processStyles.contentWrapper,
    children: /*#__PURE__*/_jsxs("div", {
      className: processStyles.content,
      children: [/*#__PURE__*/_jsx("div", {
        className: processStyles.contentHeader,
        children: "\u8CFC\u5165\u3059\u308B\u5546\u54C1"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.container,
        children: /*#__PURE__*/_jsxs("div", {
          className: `${styles.section} ${styles.column}`,
          children: [courses && courses.length === 1 && /*#__PURE__*/_jsx(SingleCourse, {
            course: courses[0],
            onChange: onChange
          }), products && products.length === 1 && /*#__PURE__*/_jsx(SingleProduct, {
            product: products[0],
            onChange: onChange
          }), products && products.length > 1 && /*#__PURE__*/_jsx(MultipleProduct, {
            products: products,
            onChange: onChange
          })]
        })
      }), /*#__PURE__*/_jsx("ul", {
        className: styles.attentionNote,
        children: /*#__PURE__*/_jsxs("li", {
          children: ["\u203B\u7279\u5B9A\u5546\u53D6\u5F15\u6CD5\u306B\u3064\u3044\u3066", /*#__PURE__*/_jsx(Link, {
            href: routes.legalSctLaw,
            target: "_blank",
            rel: "noopener noreferrer",
            className: formStyles.textLink,
            children: "\u3053\u3061\u3089"
          }), "\u304B\u3089\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"]
        })
      })]
    })
  });
}
function SingleCourse(_ref2) {
  let {
    course,
    onChange
  } = _ref2;
  const coursePrice = formatPrice((course === null || course === void 0 ? void 0 : course.defaultPrice) || 0);
  useEffect(() => {
    onChange({
      type: "svod",
      id: [Number(course.id)]
    });
  }, [course, onChange]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.table,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.row,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.label,
        children: "\u5546\u54C1\u540D"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.value,
        children: course.name
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.row,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.label,
        children: "\u4FA1\u683C"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.value,
        children: /*#__PURE__*/_jsxs("span", {
          className: styles.priceAmount,
          children: [/*#__PURE__*/_jsx("span", {
            children: "\u6708\u984D"
          }), " ", coursePrice, "\u5186", /*#__PURE__*/_jsx("span", {
            children: "\uFF08\u7A0E\u8FBC\uFF09"
          })]
        })
      })]
    })]
  });
}
function SingleProduct(_ref3) {
  let {
    product,
    onChange
  } = _ref3;
  const productPrice = formatPrice(product.price || 0);
  useEffect(() => {
    onChange({
      type: "tvod",
      id: [Number(product.id)]
    });
  }, [product, onChange]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.table,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.row,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.label,
        children: "\u5546\u54C1\u540D"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.value,
        children: product.name
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.row,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.label,
        children: "\u4FA1\u683C"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.value,
        children: /*#__PURE__*/_jsxs("span", {
          className: styles.priceAmount,
          children: [productPrice, "\u5186", /*#__PURE__*/_jsx("span", {
            children: "\uFF08\u7A0E\u8FBC\uFF09"
          })]
        })
      })]
    })]
  });
}
function MultipleProduct(_ref4) {
  let {
    products,
    onChange
  } = _ref4;
  // 最初の1件をデフォルトで選択状態にする
  const {
    0: selected,
    1: setSelected
  } = useState(products[0].id);
  const handleChange = useCallback(e => {
    setSelected(e.target.value);
  }, []);
  useEffect(() => {
    onChange({
      type: "tvod",
      id: [Number(selected)]
    });
  }, [selected, onChange]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames("flex flexWrap", {
      flex50: products.length >= 2
    }),
    children: products.map((product, i) => /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        className: `${formStyles.inputField} ${formStyles.radio}`,
        children: [/*#__PURE__*/_jsx("input", {
          type: "radio",
          name: "product",
          id: `product-${i}`,
          className: formStyles.radioButton,
          value: product.id,
          checked: product.id === selected,
          onChange: handleChange
        }), /*#__PURE__*/_jsx("label", {
          htmlFor: `product-${i}`,
          children: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("div", {
              className: "textNowwrap",
              children: product.name
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsxs("span", {
                className: styles.priceAmount,
                children: ["\u4FA1\u683C ", formatPrice(product.price), "\u5186", /*#__PURE__*/_jsx("span", {
                  children: "\uFF08\u7A0E\u8FBC\uFF09"
                })]
              })
            })]
          })
        })]
      }, `prodict-${i}`)
    }))
  });
}